import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { schoolsDB } from '../../lib/db/schools';
import { useUserProfile } from '../../hooks/useUserProfile';

export default function FocusDisplay({ focusIds }) {
  const { i18n } = useTranslation();
  const { userProfile } = useUserProfile();
  const [focusItems, setFocusItems] = useState([]);

  useEffect(() => {
    const fetchFocusItems = async () => {
      if (!focusIds || focusIds.length === 0 || !userProfile?.profile?.schoolId) {
        setFocusItems([]);
        return;
      }

      try {
        const school = await schoolsDB.getSchool(userProfile.profile.schoolId);
        if (school?.focus) {
          const items = school.focus.filter(f => focusIds.includes(f.id));
          setFocusItems(items);
        } else {
          setFocusItems([]);
        }
      } catch (error) {
        console.error('Error fetching focus items:', error);
        setFocusItems([]);
      }
    };

    fetchFocusItems();
  }, [focusIds, userProfile]);

  if (!focusItems || focusItems.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 md:gap-2 mt-1">
      {focusItems.map((focusItem) => (
        <span
          key={focusItem.id}
          className="inline-flex items-center px-2 md:px-2.5 py-0.5 md:py-1 rounded-md text-xs md:text-sm bg-primary-100 text-primary-700 font-medium"
        >
          {focusItem[`name${i18n.language === 'he' ? 'He' : 'En'}`]}
        </span>
      ))}
    </div>
  );
}

